import React from "react";

import styles from "./headerLogo.scss";
import { asset } from "../../services";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";

const HeaderLogo = ({ className, onClick }) => (
  <div className={className}>
    <Link
      to={{ pathname: "/", state: { scroll: true } }}
      onClick={() =>
        ReactGA.event({
          category: "Povratak na naslovnicu",
          action: "Click",
          label: "Logo header"
        })
      }
    >
      <img
        className={styles.logo}
        alt={"Logo"}
        src={asset.getImageUrl("new-logo.svg")}
      />
    </Link>
  </div>
);

HeaderLogo.defaultProps = {
  className: ""
};

export default React.memo(HeaderLogo);



// WEBPACK FOOTER //
// ./src/components/HeaderLogo/index.tsx